import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'gt-datetime-input',
  templateUrl: './datetime-input.component.html',
  styleUrls: ['./datetime-input.component.scss']
})
export class DatetimeInputComponent implements OnInit, OnChanges {
  @Input() parentForm: UntypedFormGroup;
  @Input() name: string;
  @Input() required = false;
  @Input() datetime: moment.Moment;
  @Input() min: moment.Moment;
  @Input() disabled = false;
  @Output() datetimeChange = new EventEmitter<moment.Moment>();

  date: moment.Moment;
  time: moment.Moment;
  dateFormControl: UntypedFormControl;

  ngOnInit() {
    this.dateFormControl = new UntypedFormControl({value: this.datetime, disabled: this.disabled}, []);
    if (this.parentForm && this.name) {
      this.parentForm.addControl(this.name, this.dateFormControl);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.disabled) {
      if (this.disabled) {
        this.dateFormControl.disable();
      } else {
        this.dateFormControl.enable();
      }
    }

    if (changes.datetime) {
      this.date = this.datetime ? this.datetime.clone() : null;
      this.time = this.datetime ? this.datetime.clone() : null;
      if (this.dateFormControl) {
        this.dateFormControl.setValue(this.datetime, {emitEvent: false});
      }
    } else if (changes.required) {
      if (this.required) {
        this.dateFormControl.setValidators(Validators.required);
      } else {
        this.dateFormControl.setValidators([]);
      }
    }
  }

  onDateChange(newDate: moment.Moment) {
    this.date = newDate;
    this.updateDate();
    this.updateTime();
    this.emitChanges();
  }

  onTimeChange(newTime: moment.Moment) {
    this.time = newTime;
    this.updateTime();
    this.emitChanges();
  }

  private updateDate() {
    this.datetime = this.date;
    if (this.datetime) {
      this.datetime.set({
        year: this.date.get('year'),
        date: this.date.get('date'),
        month: this.date.get('month')
      });
    }
  }

  private updateTime() {
    if (this.time && this.datetime) {
      this.datetime.set({
        hour: this.time.get('hour'),
        minute: this.time.get('minute')
      });
    }
  }

  emitChanges() {
    this.dateFormControl.setValue(this.datetime, {emitEvent: false});
    this.datetimeChange.emit(this.datetime);
  }

}
